import { colors } from '@procore/core-react';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  profileHeaderContainer: {
    padding: '37px 0 0px 0',
  },
  profileHeader: {
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      flexDirection: 'column',
    },
  },
  companyNameContainer: {
    width: '100%',
    [theme.breakpoints.up(960)]: {
      marginTop: '4px',
    },
  },
  mainInfoContainer: {
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      marginTop: '24px',
      flexDirection: 'column',
    },
  },
  companyLogo: {
    borderRadius: '4px',
    border: `1px solid ${colors.gray85}`,
    height: 'fit-content',
    margin: '5px 30px 5px 0px',
    padding: '5px',
  },
  companyName: {
    fontSize: '44px',
    lineHeight: '48px',
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: '-1px',
    marginBottom: '12px',
    [theme.breakpoints.down(960)]: {
      fontSize: '28px',
      lineHeight: '36px',
      fontStyle: 'normal',
      fontWeight: 700,
      letterSpacing: '-0.75px',
      marginBottom: '0px',
    },
  },
  legalName: {
    marginTop: '5px',
    color: `${colors.gray40}`,
    fontSize: '14px',
    fontWeight: 600,
  },
  legalNameTooltip: {
    position: 'relative',
    top: '2.2px',
    height: '14px',
    width: '14px',
    marginLeft: '2px',
  },
  descriptiveInfo: {
    margin: '0 10px 0 5px',
    fontSize: '16px',
    fontWeight: 400,
    textWrap: 'wrap',
    letterSpacing: '0px',
  },
  about: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0px',
  },
  isThisYourBusinessURL: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '19px',
  },
  headerLink: {
    '&, &:hover, &:focus, &:active': {
      textDecoration: 'underline',
      color: colors.blue45,
      outline: 0,
      display: 'block',
    },
    '&:hover': { color: colors.black },
    '&:focus-visible': {
      boxShadow: `0px 0px 0px 2px ${colors.blue50}`,
    },
    '&> p': {
      fontSize: '16px !important',
      fontWeight: '400 !important' as any,
      textWrap: 'wrap',
    },
  },
  showMoreOrLessText: {
    color: colors.black,
    display: 'inline-block',
    fontSize: '14px',
    textDecoration: 'underline',
    '&:hover': { cursor: 'pointer' },
  },
  shareProfileButton: {
    display: 'none',
    [theme.breakpoints.down(960)]: {
      marginTop: '10px',
      display: 'flex',
    },
  },
  claimedContainer: {
    [theme.breakpoints.down(960)]: {
      marginTop: '24px',
    },
  },
  descriptiveInfoContainer: {
    alignItems: 'baseline',
    marginBottom: '12px',
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      alignItems: 'flex-start',
      marginTop: '24px',
      marginBottom: '24px',
      flexDirection: 'column',
    },
  },
  descriptionWithIcon: {
    marginTop: '8px',
    [theme.breakpoints.down(960)]: {
      marginBottom: '8px',
    },
  },
  lastDescriptionWithIcon: {
    marginTop: '8px',
    [theme.breakpoints.down(960)]: {
      marginTop: '8px',
    },
  },
}));
